export default __webpack_public_path__ + "static/media/answerFound.6be7c7ea.mp3";